import axiosInstance from '../axiosInterceptor/axiosInstance'

const removePlayerFromSeasonTeam = async (orgId, seasonTeamPlayerId) => {
  const url = `v1/orgs/${orgId}/season-team-players/${seasonTeamPlayerId}`
  const response = await axiosInstance.delete(url)
  return response?.data
}

export default removePlayerFromSeasonTeam
